import { BLOG_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const BlogService = {
  getAll: (params: any) => requests.get(`${BLOG_URL}`, params),
  create: (params: any) => requests.post(`${BLOG_URL}`, params, true),
  getSingle: (id: number) => requests.get(`${BLOG_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.post(`${BLOG_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${BLOG_URL}/${id}`),
};